import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eventbrite/i18n';
import { formatUrl } from 'url-lib';
import { IconButton } from '@eventbrite/eds-icon-button';

import { UTM_OPTION_PROPTYPE } from './constants';
import { openUrl } from './utils';
import { LogoLinkedin } from '@eventbrite/eds-iconography';

const _getEventUrl = (eventUrl, utmOptions) =>
    formatUrl(eventUrl, {
        aff: 'esli',
        ...utmOptions,
    });

export default class LinkedinShare extends React.Component {
    static propTypes = {
        /**
         * Event's url
         */
        eventUrl: PropTypes.string.isRequired,

        /**
         * Function that onClick of one of the share options, passes
         * back an id of the clicked option
         */
        onClick: PropTypes.func,

        /**
         * utmOptions configured for this shareType
         */
        utmOptions: UTM_OPTION_PROPTYPE,
    };

    _handleButtonClick() {
        const { eventUrl, onClick, utmOptions } = this.props;
        const url = formatUrl('https://www.linkedin.com/shareArticle', {
            url: _getEventUrl(eventUrl, utmOptions),
        });

        if (onClick) {
            onClick();
        }

        openUrl(url);
    }

    render() {
        return (
            <span
                className="eds-l-pad-right-1"
                data-spec="linkedin-share-box-container"
            >
                <IconButton
                    onClick={this._handleButtonClick.bind(this)}
                    iconType={<LogoLinkedin />}
                    title={gettext('Share on Linkedin')}
                />
            </span>
        );
    }
}
